import { useEffect, useState } from "react";
import {
  EMAIL,
  Img,
  Lines,
  Logo,
  Reveal,
  SectionHead,
  useInView,
  WaIcon,
  WA_NUMBER,
  WA_URL,
} from "../lib/site";

const hitos = [
  {
    n: "1",
    dia: "Día 1",
    t: "Hablamos",
    d: "Veinte minutos, por teléfono o en tu local. Nos cuentas cómo os entran ahora los pedidos y nos pasas tu carta. Nada más.",
  },
  {
    n: "2",
    dia: "Día 2",
    t: "Lo montamos",
    d: "Cargamos tus platos, tus precios, tus horarios, tu zona de reparto y tu pedido mínimo. Lo hacemos nosotros. Tú sigues con lo tuyo.",
  },
  {
    n: "3",
    dia: "Día 3",
    t: "Lo probamos juntos",
    d: "Llamas tú, llama tu encargado, llama quien quieras. Escuchamos las grabaciones y afinamos lo que chirríe. Aquí es donde se ajusta el tono.",
  },
  {
    n: "4",
    dia: "Día 4",
    t: "Desvías el teléfono",
    d: "Le pides a tu operador que desvíe las llamadas al número que te damos. Cinco minutos y es lo único que tienes que hacer tú.",
  },
  {
    n: "5",
    dia: "Día 5",
    t: "Ya está atendiendo",
    d: "Los pedidos empiezan a llegar a cocina. Puedes escuchar cualquier llamada cuando quieras, desde el móvil.",
  },
];

export function PrimeraSemana() {
  const [ref, inView] = useInView(0.3);
  return (
    <section className="bg-papel py-28 text-noche md:py-36" data-testid="section-primera-semana">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHead num="06" label="Cómo empezamos" />
        <Lines
          className="mt-10 font-display display-track text-3xl leading-[1.05] sm:text-4xl lg:text-5xl"
          lines={["De la primera llamada", <span key="x" className="serif-accent">a estar funcionando.</span>]}
        />
        <Reveal delay={140}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-noche/75 md:text-lg">
            Sin obras, sin instalar nada y sin que tu equipo tenga que aprender
            a usar nada nuevo.
          </p>
        </Reveal>

        <div ref={ref} className={`tl mt-10${inView ? " in" : ""}`} data-testid="timeline">
          <span className="tl-line" aria-hidden="true" />
          <ol className="grid grid-cols-1 gap-12 md:grid-cols-5 md:gap-8">
            {hitos.map((h, i) => (
              <li key={h.n} className="relative pl-8 md:pl-0 md:pt-16">
                <span
                  className="tl-dot"
                  style={{ transitionDelay: `${400 + i * 160}ms` }}
                  aria-hidden="true"
                />
                <span className="serif-accent block text-5xl text-noche/30 md:text-6xl" aria-hidden="true">
                  {h.n}
                </span>
                <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.24em] text-noche/70">
                  {h.dia}
                </p>
                <h3 className="mt-2 font-display text-lg display-track">{h.t}</h3>
                <p className="mt-3 text-[13px] leading-relaxed text-noche/70">{h.d}</p>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-16">
          <Reveal className="zoomwrap aspect-[16/9] md:aspect-[21/9]">
            <Img
              src="https://images.unsplash.com/photo-1428515613728-6b4607e44363?auto=format&fit=crop&q=80&w=1800"
              alt="Cocina profesional en pleno servicio, vista desde el pase"
              name="cocina-en-servicio"
            />
          </Reveal>
        </div>

        <Reveal className="mt-16 border-t border-noche/15 pt-12">
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-noche/70">Día 15</p>
          <h3 className="mt-3 font-display text-2xl display-track md:text-3xl">Decides</h3>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-noche/75 md:text-base">
            Se acaba la prueba. Si te sirve, seguimos. Si no, lo dejas ahí y ya
            está. Sin permanencia y sin llamadas de nadie intentando
            convencerte.
          </p>
          <a href="#contacto" className="btn btn-dark mt-10" data-testid="timeline-demo-button">
            Empezar ahora
          </a>
        </Reveal>
      </div>
    </section>
  );
}

const llamadasOpts = ["Menos de 20", "Entre 20 y 50", "Entre 50 y 100", "Más de 100", "Ni idea"];

function DemoForm() {
  const [form, setForm] = useState({ nombre: "", ciudad: "", telefono: "", llamadas: "", mensaje: "", empresa: "" });
  const [priv, setPriv] = useState(false);
  const [estado, setEstado] = useState("idle");

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setEstado("enviando");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/demos`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error();
      setEstado("ok");
    } catch {
      setEstado("error");
    }
  };

  if (estado === "ok") {
    return (
      <div data-testid="form-success" className="py-10">
        <p className="font-display text-2xl display-track">Recibido.</p>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-noche/75">
          Te escribimos hoy mismo para quedar y enseñártelo en tu local.
          Si te corre prisa, estamos en{" "}
          <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="underline underline-offset-4">
            WhatsApp
          </a>
          .
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} noValidate={false} data-testid="demo-form">
                <div className="grid grid-cols-1 gap-7 sm:grid-cols-2">
                  <div className="f-field">
                    <label htmlFor="f-nombre">Nombre del local</label>
                    <input id="f-nombre" name="nombre" required value={form.nombre} onChange={onChange} data-testid="form-nombre" autoComplete="organization" />
                  </div>
                  <div className="f-field">
                    <label htmlFor="f-ciudad">Ciudad</label>
                    <input id="f-ciudad" name="ciudad" required value={form.ciudad} onChange={onChange} data-testid="form-ciudad" autoComplete="address-level2" />
                  </div>
                  <div className="f-field">
                    <label htmlFor="f-telefono">Teléfono</label>
                    <input id="f-telefono" name="telefono" type="tel" required value={form.telefono} onChange={onChange} data-testid="form-telefono" autoComplete="tel" />
                  </div>
                  <div className="f-field">
                    <label htmlFor="f-llamadas">Llamadas al día</label>
                    <select id="f-llamadas" name="llamadas" required value={form.llamadas} onChange={onChange} data-testid="form-llamadas">
                      <option value="" disabled>Elige una opción</option>
                      {llamadasOpts.map((o) => (
                        <option key={o} value={o}>{o}</option>
                      ))}
                    </select>
                  </div>
                  <div className="f-field sm:col-span-2">
                    <label htmlFor="f-mensaje">Cuéntanos cómo os entran los pedidos</label>
                    <textarea id="f-mensaje" name="mensaje" value={form.mensaje} onChange={onChange} data-testid="form-mensaje" />
                  </div>
                </div>
                <div className="hp" aria-hidden="true">
                  <label htmlFor="f-empresa">Empresa</label>
                  <input id="f-empresa" name="empresa" tabIndex={-1} aria-hidden="true" autoComplete="off" value={form.empresa} onChange={onChange} />
                </div>
                <label className="mt-8 flex cursor-pointer items-start gap-3" data-testid="form-privacidad-label">
                  <input
                    type="checkbox"
                    required
                    checked={priv}
                    onChange={(e) => setPriv(e.target.checked)}
                    className="chk-box"
                    name="privacidad"
                    data-testid="form-privacidad-checkbox"
                  />
                  <span className="text-[12px] leading-relaxed text-noche/80">
                    He leído y acepto la{" "}
                    <a href="/politica-de-privacidad" className="underline underline-offset-4" data-testid="form-privacidad-link">
                      política de privacidad
                    </a>
                  </span>
                </label>
                <p className="mt-4 text-[11px] leading-relaxed text-noche/70" data-testid="form-info-rgpd">
                  Responsable: José María Fernández Kherraz. Finalidad: atender tu solicitud
                  de demostración. Derechos: acceso, rectificación, supresión y
                  demás recogidos en la política de privacidad.
                </p>
                {estado === "error" && (
                  <p className="mt-6 font-mono text-[12px] text-noche" data-testid="form-error">
                    No ha podido enviarse. Escríbenos por WhatsApp y lo vemos ahora mismo.
                  </p>
                )}
                <button type="submit" className="btn btn-dark mt-8 w-full sm:w-auto" disabled={estado === "enviando"} data-testid="form-submit-button">
                  {estado === "enviando" ? "Enviando…" : "Empezar ahora"}
                </button>
    </form>
  );
}

export function Contacto() {
  return (
    <section id="contacto" className="bg-hondo py-28 text-crema md:py-36" data-testid="section-contacto">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-5 md:px-8 lg:grid-cols-2">
        <div className="flex flex-col justify-center">
          <SectionHead num="07" label="Contacto" />
          <Lines
            className="mt-10 font-display display-track text-3xl leading-[1.05] sm:text-4xl lg:text-5xl"
            lines={["Te lo enseñamos", <span key="x" className="serif-accent">en tu local.</span>]}
          />
          <Reveal delay={140}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-crema/80 md:text-lg">
              Cuéntanos cómo os entran los pedidos ahora y te decimos en dos
              minutos si Kanvia te encaja. Si no te encaja, también te lo
              decimos.
            </p>
          </Reveal>
          <Reveal delay={220}>
            <a
              href={`mailto:${EMAIL}`}
              className="mt-10 block font-display text-xl display-track transition-opacity duration-300 hover:opacity-60 md:text-2xl"
              data-testid="contact-email-link"
            >
              {EMAIL}
            </a>
            <a
              href={WA_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Escríbenos por WhatsApp"
              className="mt-5 inline-flex flex-wrap items-center gap-3 font-display text-xl display-track transition-opacity duration-300 hover:opacity-60 md:text-2xl"
              data-testid="contact-whatsapp-link"
            >
              <WaIcon className="h-6 w-6 shrink-0" />
              <span>WhatsApp · {WA_NUMBER}</span>
            </a>
          </Reveal>
          <Reveal delay={280}>
            <p className="mt-12 max-w-md border-t border-salvia/15 pt-8 text-sm leading-relaxed text-crema/80">
              Si te resulta más cómodo, mándanos un audio por WhatsApp
              contándonos cómo trabajáis y te contestamos con la demo ya
              montada para tu carta.
            </p>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-crema/70">
              Sin compromiso · Te contestamos el mismo día
            </p>
          </Reveal>
        </div>

        <div className="relative">
          <Reveal className="aspect-[4/5] overflow-hidden">
            <Img
              src="https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?auto=format&fit=crop&q=80&w=1200"
              alt="Sala de restaurante en penumbra con lámparas cálidas encendidas"
              name="sala-en-penumbra"
              className="h-full w-full object-cover"
            />
          </Reveal>
          <Reveal delay={140} className="relative z-10 -mt-24 ml-5 mr-5 bg-papel p-8 text-noche md:p-10 lg:-ml-16 lg:mr-0">
            <DemoForm />
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  const year = new Date().getFullYear();
  const nav = [
    { href: "/", label: "Inicio", id: "inicio" },
    { href: "/#como-funciona", label: "Cómo funciona", id: "como-funciona" },
    { href: "/#preguntas", label: "Preguntas", id: "preguntas" },
    { href: "/#contacto", label: "Contacto", id: "contacto" },
  ];
  const legal = [
    { href: "/aviso-legal", label: "Aviso legal", id: "aviso" },
    { href: "/politica-de-privacidad", label: "Política de privacidad", id: "privacidad" },
    { href: "/politica-de-cookies", label: "Política de cookies", id: "cookies" },
  ];
  return (
    <footer className="border-t border-salvia/15 bg-hondo py-16 text-crema" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between">
          <div className="flex items-center gap-3">
            <Logo className="h-8 w-8" />
            <span className="wordmark font-display text-[21px] display-track font-semibold">
              Kanvia<span className="serif-accent text-salvia" aria-hidden="true">.</span>
            </span>
          </div>
          <nav aria-label="Navegación del pie" className="grid grid-cols-2 gap-x-14 gap-y-3 font-mono text-[12px]">
            <div className="flex flex-col gap-3">
              {nav.map((l) => (
                <a
                  key={l.id}
                  href={l.href}
                  className="transition-opacity duration-300 hover:opacity-60"
                  data-testid={`footer-nav-${l.id}`}
                >
                  {l.label}
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-3">
              {legal.map((l) => (
                <a
                  key={l.id}
                  href={l.href}
                  className="transition-opacity duration-300 hover:opacity-60"
                  data-testid={`footer-legal-${l.id}`}
                >
                  {l.label}
                </a>
              ))}
              <button
                type="button"
                onClick={() => window.dispatchEvent(new Event("kanvia:cookies"))}
                className="text-left transition-opacity duration-300 hover:opacity-60"
                data-testid="footer-configurar-cookies"
              >
                Configurar cookies
              </button>
            </div>
          </nav>
          <div className="flex flex-col gap-3 font-mono text-[12px]">
            <a href={`mailto:${EMAIL}`} className="transition-opacity duration-300 hover:opacity-60" data-testid="footer-email-link">
              {EMAIL}
            </a>
            <a
              href={WA_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Escríbenos por WhatsApp"
              className="inline-flex items-center gap-2 transition-opacity duration-300 hover:opacity-60"
              data-testid="footer-whatsapp-link"
            >
              <WaIcon className="h-4 w-4" />
              <span>WhatsApp · {WA_NUMBER}</span>
            </a>
          </div>
        </div>
        <p className="mt-14 max-w-3xl text-[12px] leading-relaxed text-crema/70">
          Kanvia atiende las llamadas mediante un asistente de voz automático.
          Al inicio de la llamada se informa a quien llama de que habla con un
          sistema automático, y puede pedir en cualquier momento que se le pase
          con una persona. Las llamadas se graban y se tratan únicamente para
          gestionar el pedido y mejorar el servicio, conforme al RGPD. El
          restaurante es responsable de informar a sus clientes de la grabación.
        </p>
        <p className="mt-8 font-mono text-[11px] text-crema/70" data-testid="footer-copyright">
          © {year} Kanvia. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}

export function WhatsAppFloat() {
  const [past, setPast] = useState(false);
  const [nearContact, setNearContact] = useState(false);

  useEffect(() => {
    const onScroll = () => setPast(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    const el = document.getElementById("contacto");
    let io;
    if (el) {
      io = new IntersectionObserver(([e]) => setNearContact(e.isIntersecting), { threshold: 0.05 });
      io.observe(el);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (io) io.disconnect();
    };
  }, []);

  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escríbenos por WhatsApp"
      data-testid="whatsapp-float-button"
      className={`wa-float${past && !nearContact ? " show" : ""}`}
    >
      <WaIcon className="h-6 w-6" />
    </a>
  );
}
